<template>
    <div>
        <ChangeUserEmailModal
            v-if="user && allowsUsersEmailManagement"
            ref="changeUserEmailModal"
            :user="user"
            @update="handleEmailUpdated"
        />
        <div class="vx-card p-8 mt-8">
            <h4 class="mb-4">Actions</h4>
            <div class="flex flex-wrap items-center gap-4">
                <button v-if="allowsUsersEmailManagement" class="sk-btn sk-btn-primary rounded-lg" @click="handleChangeEmail">
                    {{ $t('admin.users.actions.change_email') }}
                </button>
                <button v-if="allowsUsersEmailManagement" class="sk-btn sk-btn-primary rounded-lg" @click="handleResendRestorePasswordEmail">
                    {{ $t('admin.users.actions.resend_restore_password_email') }}
                </button>
                <button v-if="canValidateEmail" class="sk-btn sk-btn-primary rounded-lg" @click="handleValidateEmail">
                    {{ $t('admin.users.actions.validate_email') }}
                </button>
                <button class="sk-btn sk-btn-primary rounded-lg" @click="handleToggleRole">
                    {{ isEditor
                        ? $t('apps.registered-users.actions.demote_to_user')
                        : $t('apps.registered-users.actions.promote_to_editor') }}
                </button>
            </div>
        </div>
        <div class="vx-card p-8 mt-8">
            <img :src="user.avatar ? user.avatar : AVATAR_FALLBACK" class="w-32 h-32 rounded-full mb-4">
            <div class="flex flex-row gap-2">
               <p class="font-bold">{{ $t('shops.username') }}:</p>
               <p>{{ user.username }}</p>
            </div>
            <div class="flex flex-row gap-2">
                <p class="font-bold">{{ $t('shops.id') }}:</p>
                <p>{{ user.id }}</p>
            </div>
            <div class="flex flex-row gap-2">
                <p class="font-bold">Uuid:</p>
                <p>{{ user.uuid }}</p>
            </div>
            <div class="flex flex-row gap-2">
                <p class="font-bold">{{ $t('shops.email') }}:</p>
                <p>{{ user.email }}</p>
            </div>
            <div class="flex flex-row gap-2">
                <p class="font-bold">{{ $t('admin.users.form.firstname') }}:</p>
                <p>{{ user.name ? user.name : '-' }}</p>
            </div>
            <div class="flex flex-row gap-2">
                <p class="font-bold">{{ $t('admin.users.form.lastname') }}:</p>
                <p>{{ user.surname ? user.surname : '-' }}</p>
            </div>
            <div class="flex flex-row gap-2">
                <p class="font-bold">{{ $t('apps.registered-users.language') }}:</p>
                <p>{{ user.language }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import store from "@/modules/Shared/Store/store";
import UsersService from "@/modules/Apps/Services/UsersService";
import ChangeUserEmailModal from "@/modules/Apps/Components/users/ChangeUserEmailModal.vue";
import loader from "@/modules/Shared/Mixins/loader";
import {mapGetters} from "vuex";

const AVATAR_FALLBACK = 'https://userdatacf.skitude.com/images/photo_profile.png'
const ROLE_EDITOR = 'editor'
const ROLE_CLIENT = 'client'

export default {
    name: "UserDetail",
    components: {ChangeUserEmailModal},
    mixins: [loader],

    data() {
        return {
            user: null,
            AVATAR_FALLBACK
        }
    },
    async beforeRouteEnter(to, from, next) {
        const user = await UsersService.getUser(to.params.uuid, to.params.userUuid)

        await store.dispatch('setRouteElement', user)
        next(vm => {
            vm.user = user
        })
    },
    computed: {
        ...mapGetters('apps', ['app']),
        appUuid() {
            return this.$route.params.uuid
        },
        allowsUsersEmailManagement() {
            const app = this.app(this.appUuid)
            return !!app && !!app.allows_users_email_management
        },
        userUuid() {
            return this.$route.params.userUuid
        },
        isEditor() {
            return this.user.role === ROLE_EDITOR
        },
        canValidateEmail() {
            return this.allowsUsersEmailManagement && !this.user.email_validated
        }
    },
    methods: {
        async getUser() {
            this.user = await UsersService.getUser(this.appUuid, this.userUuid)
        },
        async handleChangeEmail() {
            await this.$refs.changeUserEmailModal.open()
        },
        async handleEmailUpdated() {
            await this.getUser()
        },
        async handleResendRestorePasswordEmail() {
            await this.loadAndNotify(async () => {
                await UsersService.sendRestorePasswordEmail(this.appUuid, this.userUuid)
            })
        },
        async handleValidateEmail() {
            await this.loadAndNotify(async () => {
                await UsersService.editUser(this.appUuid, this.userUuid, { email_validated: true })
                this.user = { ...this.user, email_validated: true }
            })
        },
        async handleToggleRole() {
            const role = this.isEditor ? ROLE_CLIENT : ROLE_EDITOR

            await this.loadAndNotify(async () => {
                await UsersService.editUser(this.appUuid, this.userUuid, { role })
                this.user = { ...this.user, role }
            })
        }
    }
}
</script>
